import { Button } from "antd";
import { PopOver } from "../elements/PopOver";
import { IconButton } from "@mui/material";
import { MoreHoriz } from "@mui/icons-material";
import { GenericModal } from "../elements/GenericModal";

export const Actions = ({ actions }) => {
  return (
    <PopOver
      button={
        <IconButton>
          <MoreHoriz />
        </IconButton>
      }
    >
      <div>
        {actions?.map((val, i) => {
          const { action, click, confirm } = val;
          return (
            <div key={i}>
              {confirm ? (
                <GenericModal
                  onOk={click}
                  message="Are you sure proceed this task?"
                  title={`Confirm ${action}`}
                  component={
                    <Button
                      type="text"
                      style={{
                        width: "100%",
                        textAlign: "start",
                        fontSize: 13,
                        padding: "0 5px",
                      }}
                    >
                      {action}
                    </Button>
                  }
                />
              ) : (
                <Button
                  onClick={click}
                  type="text"
                  style={{
                    width: "100%",
                    textAlign: "start",
                    fontSize: 13,
                    padding: "0 5px",
                  }}
                >
                  {action}
                </Button>
              )}
            </div>
          );
        })}
      </div>
    </PopOver>
  );
};
